import authInterceptor from "../AuthInterceptor";

export const UpdateRankStatus = {
    updateStatus: (bodyData) =>
        authInterceptor.post(`ranking-api/update-status/`, bodyData)
            .then((response) => response.data)
            .catch((error) => error.response),
    updateAssignee: (bodyData) =>
        authInterceptor.post(`ranking-api/update-assignee/`, bodyData)
            .then((response) => response.data)
            .catch((error) => error.response),
}